import { format } from "date-fns";
import { get } from "lodash";

import { TCatalog_identifier } from "~/model/Instances/TCatalog";
import { TSectionsList } from "~/pages/Editor/EditorDocumentSection";
import { ICatalogCreateForm } from "~/pages/Editor/EditorDocumentSection/modals/CatalogForm";
import { ICatalogCreateSignature } from "~/pages/Editor/EditorDocumentSection/modals/CatalogModal";

type TDocumentSectionLiterals = {
  defaultCatalogList: TSectionsList;
};
export const documentSectionLiterals: TDocumentSectionLiterals = {
  defaultCatalogList: {
    total: 0,
    items: [],
  },
};

export const GetNormalizedCatalogList_EditorDocumentSection = (
  response: unknown,
): TSectionsList => {
  const data = get(
    response,
    "DocumentGetter.getSections",
    documentSectionLiterals.defaultCatalogList,
  ) as TSectionsList;
  return {
    ...data,
    items: data.items.map((el) => ({
      ...el,
      createdAt: format(new Date(el.createdAt), "dd.MM.yyyy"),
    })),
  };
};

export const convertDataToRequestCreateCatalog_CatalogModal = (
  data: ICatalogCreateForm,
): ICatalogCreateSignature => {
  return {
    ...data,
    parentId: data?.parentId?.value ? String(data?.parentId?.value) : undefined,
  };
};

const defaultValues = {
  name: "",
  parentId: { value: null, label: "Не выбран" },
};
export const getValuesFromInstance_CatalogModal = (
  data: TCatalog_identifier,
  excludeName?: boolean,
): ICatalogCreateForm => {
  if (!data) return defaultValues;
  if (excludeName) {
    return {
      ...defaultValues,
      parentId: data.id
        ? { value: data.parentId, label: data.parentName }
        : { value: null, label: "Не выбран" },
    };
  }
  return {
    name: data.name,
    parentId: data.parentId
      ? { value: data.parentId, label: data.parentName }
      : { value: null, label: "Не выбран" },
  };
};
